import type { CancelablePromise } from "../client"
import { OpenAPI } from "../client"
import { request as __request } from "../client/core/request"

export type InitTransferMMWDraftDTO = {
  from_warehouse_id: string
  to_warehouse_id: string
  description?: string
}

export type TransferMMWDraftResponseDTO = {
  id: string
  number: string
  status: string
  document_type: string
  created_at: string
}

export const TransferMMWDraftsService = {
  initDocumentMMWDraft: (
    payload: InitTransferMMWDraftDTO,
  ): CancelablePromise<TransferMMWDraftResponseDTO> =>
    __request(OpenAPI, {
      method: "POST",
      url: "/v1/transfers/MMW/drafts",
      body: payload,
      mediaType: "application/json",
    }),

  deleteDocumentMMWDraft: (id: string): CancelablePromise<void> =>
    __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/transfers/MMW/{id}",
      path: { id },
    }),
}
